import { createContext, useContext, useState } from 'react';

type StatusModalContextType = {
  isPlusSuccessModalOpen: boolean;
  setIsPlusSuccessModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isStartupSuccessModalOpen: boolean;
  setIsStartupSuccessModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isStartupV0SuccessModalOpen: boolean;
  setIsStartupV0SuccessModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isPartnerSuccessModalOpen: boolean;
  setIsPartnerSuccessModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isPremierSuccessModalOpen: boolean;
  setIsPremierSuccessModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  error: string | null;
  setError: React.Dispatch<React.SetStateAction<string | null>>;
};

const StatusModalContext = createContext<StatusModalContextType | null>(null);
const StatusModalProvider = ({ children }) => {
  const [isPlusSuccessModalOpen, setIsPlusSuccessModalOpen] = useState(false);
  const [isStartupSuccessModalOpen, setIsStartupSuccessModalOpen] =
    useState(false);
  const [isStartupV0SuccessModalOpen, setIsStartupV0SuccessModalOpen] =
    useState(false);
  const [isPartnerSuccessModalOpen, setIsPartnerSuccessModalOpen] =
    useState(false);
  const [isPremierSuccessModalOpen, setIsPremierSuccessModalOpen] =
    useState(false);
  const [error, setError] = useState<string | null>(null);

  return (
    <StatusModalContext.Provider
      value={{
        isPlusSuccessModalOpen,
        setIsPlusSuccessModalOpen,
        isStartupSuccessModalOpen,
        setIsStartupSuccessModalOpen,
        isStartupV0SuccessModalOpen,
        setIsStartupV0SuccessModalOpen,
        isPartnerSuccessModalOpen,
        setIsPartnerSuccessModalOpen,
        isPremierSuccessModalOpen,
        setIsPremierSuccessModalOpen,
        error,
        setError,
      }}
    >
      {children}
    </StatusModalContext.Provider>
  );
};

const useStatusModals = () => {
  const context = useContext(StatusModalContext);
  if (!context) {
    throw new Error(
      'Status modal context should be used within StatusModalProvider'
    );
  }

  const STATE_MAPPING = {
    plus: {
      isOpen: context.isPlusSuccessModalOpen,
      setOpen: context.setIsPlusSuccessModalOpen,
    },
    startup: {
      isOpen: context.isStartupSuccessModalOpen,
      setOpen: context.setIsStartupSuccessModalOpen,
    },
    startup_v0: {
      isOpen: context.isStartupV0SuccessModalOpen,
      setOpen: context.setIsStartupV0SuccessModalOpen,
    },
    partner: {
      isOpen: context.isPartnerSuccessModalOpen,
      setOpen: context.setIsPartnerSuccessModalOpen,
    },
    premier: {
      isOpen: context.isPremierSuccessModalOpen,
      setOpen: context.setIsPremierSuccessModalOpen,
    },
  };

  const isOpen = (modalPlan: string): boolean =>
    STATE_MAPPING[modalPlan].isOpen;
  const setOpen = (
    modalPlan: string
  ): React.Dispatch<React.SetStateAction<boolean>> =>
    STATE_MAPPING[modalPlan].setOpen;

  return {
    isOpen,
    setOpen,
    error: context.error,
    setError: context.setError,
  };
};

export { StatusModalContext, StatusModalProvider, useStatusModals };
